import { msg } from '@lingui/macro'

import * as React from 'react'
import { VError } from 'verror'

import { useErrorHandlerCtx } from '~logic/errors/ErrorHandlerProvider'
import { useTrans } from '~logic/i18n/useTrans'
import { captureWithSentry } from '~logic/sentry/captureWithSentry'

type TSentryEventId = string | undefined

/**
 * Handles errors that occurred during order submit,
 * which are mostly BE validation errors or Payment Gate errors.
 */
export const useSubmitErrors = () => {
  const { trans } = useTrans()
  const { presentError } = useErrorHandlerCtx()

  // present errors thrown during order (form) submitting or during the payment
  const onSubmitFailed = React.useCallback(
    (submitErrors?: RoA<string>, reportToSentry = false) => {
      const errors = submitErrors

      let sentryEventId: TSentryEventId

      if (reportToSentry) {
        sentryEventId = captureWithSentry({ error: new VError(errors?.join('; ')) })
      }

      presentError({
        errorText: errors ?? `The order has not been submitted`,
        headerText: trans(msg`Validation unsuccessful!`),
        errorType: `handled`,
        sentryEventId,
      })
    },
    [presentError, trans],
  )

  return { onSubmitFailed }
}
